import Vue from 'vue';

export default {
  setProfile: (state, profile) => {
    state.profile = profile;
  },
  setProfilePid: (state, pid) => {
    state.profilePid = pid;
  },
  setProfileLoading: (state, loading) => {
    state.profileLoading = loading;
  },
  setProfileUpdating: (state, updating) => {
    state.profileUpdating = updating;
  },
  updateProfileField: (state, { field, value }) => {
    if (!state.profile) return;
    state.profile[field] = value;
  },
  setRole: (state, role) => {
    state.role = role;
  },
  setProfileFields: (state, fields) => {
    state.profileFields = fields;
  },
  // A successful profile save already persisted these ids. Write them onto the
  // cached field list so a later fields refresh can fail without leaving the
  // previous selection for the next visit.
  patchProfileFieldRecordIds: (state, updates) => {
    const fields = state.profileFields;
    if (!fields || !updates || Array.isArray(updates)) return;

    Object.keys(updates).forEach((key) => {
      const ids = updates[key];
      if (!Array.isArray(ids)) return;

      const field = fields[key];
      if (
        !field ||
        field.type !== 'related_custom_object' ||
        !field.multiple
      ) {
        return;
      }

      Vue.set(field, 'custom_record_ids', ids.slice());
    });
  },
  setScormParameters: (state, parameters) => {
    state.scormParameters = parameters;
  },
  togglePortalSidebar: (state, open) => {
    state.isSidebarOpen = open;
  },
};
